// src/App.js

import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, Outlet } from 'react-router-dom';

// Componentes
import Sidebar from './components/Sidebar';
import PrivateRoute from './components/PrivateRoute'; // O guardião que criamos

// Páginas
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Pacientes from './pages/Pacientes';
import FolhaVisita from './pages/FolhaVisita';
import AcompanhamentoHipertensos from './pages/AcompanhamentoHipertensos';
import AcompanhamentoDiabeticos from './pages/AcompanhamentoDiabeticos';
import AcompanhamentoGestantes from './pages/AcompanhamentoGestantes';
import AcompanhamentoDesenvolvimentoInfantil from './pages/AcompanhamentoDesenvolvimentoInfantil';
import AcompanhamentoIdosos from './pages/AcompanhamentoIdosos';
import AcompanhamentoMulheres from './pages/AcompanhamentoMulheres';
import './App.css';
import LancamentoVisita from './pages/LancamentoVisita';
import Backoffice from './pages/Backoffice';

// Componente simples para páginas em construção
const AcompanhamentoPage = ({ title }) => (
  <div style={{ padding: '20px' }}>
    <h1>{title}</h1>
    <p>Página em construção...</p>
  </div>
);

function App() {
  const [user, setUser] = useState(null);

  // Verifica o usuário ao carregar
  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

// 🛡️ VIGIA DE INATIVIDADE (LGPD) - 15 Minutos
  useEffect(() => {
    let timeoutId;

    const logoutForInactivity = () => {
      // O tiro de misericórdia só acontece se o token realmente estiver lá
      if (localStorage.getItem('token')) {
        console.warn("⏳ Sessão encerrada por inatividade.");
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('lancamentoVisitData');
        window.location.href = '/login?session_expired=true';
      }
    };

    const resetTimer = () => {
      if (timeoutId) clearTimeout(timeoutId);
      
      // O cronômetro só começa a rodar se o usuário estiver logado
      if (localStorage.getItem('token')) {
        timeoutId = setTimeout(logoutForInactivity, 900000); // 900.000 ms = 15 minutos
      }
    };

    const activityEvents = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];

    // Inicia a primeira verificação
    resetTimer();

    // Adiciona os "ouvidos" na tela
    activityEvents.forEach(evt => window.addEventListener(evt, resetTimer));

    return () => {
      if (timeoutId) clearTimeout(timeoutId);
      activityEvents.forEach(evt => window.removeEventListener(evt, resetTimer));
    };
  }, []); // Pode manter vazio, agora ele é à prova de falhas!

  // Função para atualizar o estado ao logar
  const handleLoginSuccess = (userData) => {
    setUser(userData);
  };

  // Função de Logout
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    window.location.href = '/login'; // Força o redirecionamento
  };

  // --- LAYOUT INTERNO (Só aparece quando logado) ---
  const PrivateLayout = () => (
    <div className="App">
      {/* Passamos o user e logout para a Sidebar */}
      <Sidebar user={user} onLogout={handleLogout} />
      <main className="content">
        {/* O Outlet renderiza a página selecionada (Dashboard, Pacientes, etc) */}
        <Outlet />
      </main>
    </div>
  );

  return (
    <Routes>
      {/* --- ROTA PÚBLICA --- */}
      {/* Se acessar /login, mostra a tela de login */}
      <Route path="/login" element={<Login onLoginSuccess={handleLoginSuccess} />} />

      {/* --- ROTAS PROTEGIDAS --- */}
      {/* O PrivateRoute protege todas as rotas dentro dele */}
      <Route element={<PrivateRoute />}>
        
        {/* O PrivateLayout adiciona a Sidebar e a estrutura visual */}
        <Route element={<PrivateLayout />}>
          
          {/* Se acessar a raiz "/" vai para o Dashboard */}
          <Route path="/" element={<Dashboard user={user} />} />
          <Route path="/dashboard" element={<Dashboard user={user} />} />
          <Route path="/pacientes" element={<Pacientes />} />
          <Route path="/folha-visita" element={<FolhaVisita />} />
          <Route path="/lancamento" element={<LancamentoVisita />} />
          <Route path="/hipertensos" element={<AcompanhamentoHipertensos />} />
          <Route path="/diabeticos" element={<AcompanhamentoDiabeticos />} />
          <Route path="/gestantes" element={<AcompanhamentoGestantes />} />
          <Route path="/desenvolvimento-infantil" element={<AcompanhamentoDesenvolvimentoInfantil />} />
          <Route path="/idosos" element={<AcompanhamentoIdosos />} />
          <Route path="/saude-mulher" element={<AcompanhamentoMulheres title="Prevenção ao Câncer Feminino" />} />
          <Route path="/admin" element={<Backoffice />} /> {/* NOSSA NOVA ROTA AQUI */}
          
        </Route>
      </Route>

      {/* Rota pega-tudo: Se digitar qualquer coisa errada, manda pro Login */}
      <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
  );
}

export default App;